import React, { useState, useEffect } from 'react';
import useAxios from "axios-hooks";
import { Modal, Alert as BSALert } from "react-bootstrap";
import EmailsTable from './email-table';
import { FormattedMessage } from "react-intl";


const EmailsSent = ({ show, eventId, hide }) => {
    const [flag, setFlag] = useState(false);
    const [{ data, loading }, getEmailsSent] = useAxios({
        url: `${process.env.REACT_APP_API_HOST}/event/${eventId}/emails`,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        method: "GET",
    }, {
        manual: true,
    });

    useEffect(() => {
        if(show) {
            setFlag(true)
            getEmailsSent();
        }
    }, [show, getEmailsSent]);

    return <Modal className="email-console-modal" show={show} onHide={hide} size="xl">
        <Modal.Header closeButton>
            <Modal.Title>
                <FormattedMessage id="email.sent" />
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {
                !flag || loading
                    ? <BSALert variant="warning"><FormattedMessage id="email.fetch.wait" /></BSALert>
                    : <EmailsTable data={data} />
            }
        </Modal.Body>
    </Modal>
}



export default EmailsSent;
